import React, { useRef, useState } from 'react';
import ReportHeader from '../component/report-header/ReportHeader';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import AHMIS, { API_URL } from '../../../api/api';
import AddAlertMessage from '../../../components/alert/Alert';
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from '../../../utils/constants';
import MessageBlock from '../../admin/components/message-block/MessageBlock';
import PatientCountCell from '../../../components/patient-count-cell/PatientCountCell';

const HomeoPathyReport = () => {
  const [tableData, setTableData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {

    const url = `${API_URL.hemeoPathyReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url).then(response => {
      const jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        setTableData(jsondata.data);
      } else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      }
    }).catch(error => {
      AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
    });
  };

  return (
    <>
      <ReportHeader title="होमियोप्याथी सेवा प्रतिवेदन"
        getReportData={getReportData}
        reportData={Boolean(tableData)}
        printComponentRef={printComponentRef}
      />
      {
        tableData ? (
          <Box ref={printComponentRef}>
            <TableContainer classes={{ root: 'fixed-head-table-container' }}>
              <Table classes={{ root: 'table-bordered normal-spacing' }} size="small">
                <TableHead classes={{ root: 'align-center fixed-header header-sm' }}>
                  <TableRow>
                    <TableCell colSpan={2}>सेवाको विवरण</TableCell>
                    <TableCell>सेवा संख्या</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody classes={{ root: 'align-center' }}>
                  <TableRow>
                    <TableCell rowSpan={3}>नयाँ सेवाग्राही संख्या</TableCell>
                    <TableCell >महिला</TableCell>
                    <PatientCountCell data={tableData?.NEW_PATIENT?.["FEMALE"]} />
                  </TableRow>
                  <TableRow>
                    <TableCell>पुरुष</TableCell>
                    <PatientCountCell data={tableData?.NEW_PATIENT?.["MALE"]} />
                
                  </TableRow>
                  <TableRow>
                    <TableCell>अन्य</TableCell>
                    <PatientCountCell data={tableData?.NEW_PATIENT?.["OTHER"]} />
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={3}>पुनरावृत्त सेवाग्राहीको संख्या</TableCell>
                    <TableCell >महिला</TableCell>
                    <PatientCountCell data={tableData?.PREVIOUS_PATIENT?.["FEMALE"]} />

                  </TableRow>
                  <TableRow>
                    <TableCell>पुरुष</TableCell>
                    <PatientCountCell data={tableData?.PREVIOUS_PATIENT?.["MALE"]} />

                  </TableRow>
                  <TableRow>
                    <TableCell>अन्य</TableCell>
                    <PatientCountCell data={tableData?.PREVIOUS_PATIENT?.["OTHER"]} />

                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ) : (
          <MessageBlock text={REPORT_NOT_DRAWN} />
        )
      }
    </>
  );
};

export default HomeoPathyReport;
